import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import { isOneFilterSelected, isOneTargetSelected } from 'utils/objectives';
import { DirectSalesLineObjective } from 'components/common/types/DirectSalesCampaign.types';

interface UseObjectivesEllipsesProps {
  initialObjectiveState?: DirectSalesLineObjective;
}

const useObjectivesEllipses = ({ initialObjectiveState }: UseObjectivesEllipsesProps): boolean => {
  const { isChange, isSubsectionChange } = useSelector((state: Store) => state.objective.settings);

  return useMemo((): boolean => {
    if (!initialObjectiveState) return false;

    if (!isOneTargetSelected(initialObjectiveState) && !isOneFilterSelected(initialObjectiveState)) return true;

    return isChange || isSubsectionChange;
  }, [isChange, isSubsectionChange, initialObjectiveState]);
};

export default useObjectivesEllipses;
